import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";

export function TableModal({ info, pastPassangers, setInfo, add, dismiss }) {
  return (
    <div
      className="modal fade"
      id="add-passanger-modal"
      tabindex="-1"
      aria-hidden="true"
      key={1000}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered the-reserve-modal1">
        <div className="modal-content">
          <div className="modal-header border-0">
            <ul className="nav nav-tabs w-75" id="signup-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="old-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#old"
                  type="button"
                  role="tab"
                  aria-controls="old"
                  aria-selected="true"
                >
                  لیست همراهان قبلی
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="new-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#new"
                  type="button"
                  role="tab"
                  aria-controls="new"
                  aria-selected="false"
                >
                  ثبت همراه جدید
                </button>
              </li>
            </ul>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body py-3 px-5"
            style={{ minHeight: "400px", maxHeight: "400px", overflow: "auto" }}
          >
            <div className="tab-content" id="signup-tab-content">
              <div
                className="tab-pane fade show active"
                id="old"
                role="tabpanel"
                aria-labelledby="old-tab"
              >
                <div className="the-reserve-table">
                  <div className="d-flex flex-column align-items-center table">
                    <div className="row d-none d-md-flex the-head">
                      <div className="col-3"> نام </div>
                      <div className="col-3"> نام خانوادگی </div>
                      <div className="col-3"> کد ملی </div>
                      <div className="col-3"> شماره تماس </div>
                    </div>
                    {pastPassangers.map((passanger, index) => (
                      <>
                        <div
                          className="the-tr row d-none d-md-flex"
                          key={"mm" + index * 2}
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => add({ ...passanger })}
                        >
                          <div className="the-td col-3">
                            {passanger.firstname}
                          </div>
                          <div className="the-td col-3">
                            {passanger.lastname}
                          </div>
                          <div className="the-td col-3">{passanger.code}</div>
                          <div className="the-td col-3">{passanger.phone}</div>
                        </div>
                        <div
                          className="the-tr d-md-none"
                          key={"mm" + index * 2 + 1}
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => add({ ...passanger })}
                        >
                          <div className="row">
                            <div className="col-12 col-sm-6 the-td">
                              <b> نام: </b>
                              {passanger.firstname}
                            </div>
                            <div className="col-12 col-sm-6 the-td">
                              <b> نام خانوادگی: </b>
                              {passanger.lastname}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 col-sm-6 the-td">
                              <b> کدملی: </b>
                              {passanger.code}
                            </div>
                            <div className="col-12 col-sm-6 the-td">
                              <b> شماره تماس: </b>
                              {passanger.phone}
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="new"
                role="tabpanel"
                aria-labelledby="new-tab"
              >
                <form>
                  <div className="row">
                    <label
                      htmlFor="firstname"
                      className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label the-required"
                    >
                      نام
                    </label>
                    <div className="mb-3 col-12 col-sm-6 col-lg-2">
                      <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        value={info.firstname}
                        onChange={(e) =>
                          setInfo({ ...info, firstname: e.target.value })
                        }
                      />
                    </div>
                    <label
                      htmlFor="lastname"
                      className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label the-required"
                    >
                      نام خانوادگی
                    </label>
                    <div className="mb-3 col-12 col-sm-6 col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        value={info.lastname}
                        onChange={(e) =>
                          setInfo({ ...info, lastname: e.target.value })
                        }
                      />
                    </div>
                    <label
                      htmlFor="code"
                      className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label the-required"
                    >
                      کدملی
                    </label>
                    <div className="mb-3 col-12 col-sm-6 col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        id="code"
                        value={info.code}
                        onChange={(e) =>
                          setInfo({ ...info, code: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="phone"
                      className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label the-required"
                    >
                      شماره تماس
                    </label>
                    <div className="mb-3 col-12 col-sm-6 col-lg-4">
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={info.phone}
                        onChange={(e) =>
                          setInfo({ ...info, phone: e.target.value })
                        }
                      />
                    </div>
                    <label
                      htmlFor="birthdate"
                      className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                    >
                      تاریخ تولد
                    </label>
                    <div
                      className="mb-3 col-12 col-sm-6 col-lg-4"
                      style={{ direction: "rtl" }}
                    >
                      <DatePicker
                        inputClass="form-control"
                        calendar={persian}
                        locale={persian_fa}
                        value={info.birthdate}
                        maxDate={new Date()}
                        onChange={(value) => {
                          setInfo({ ...info, birthdate: value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      htmlFor="email"
                      className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                    >
                      ایمیل
                    </label>
                    <div className="mb-3 col-12 col-sm-6 col-lg-4">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={info.email}
                        onChange={(e) =>
                          setInfo({ ...info, email: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </form>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="col-12 col-sm-5 col-lg-3 btn btn-primary the-btn"
                    data-bs-dismiss={dismiss}
                    onClick={() => add(info)}
                  >
                    ثبت
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
